var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.547 0H4.453A4.453 4.453 0 0 0 0 4.453v10.094A4.453 4.453 0 0 0 4.453 19h10.094A4.453 4.453 0 0 0 19 14.547V4.453A4.453 4.453 0 0 0 14.547 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    d: "M14.547 0H4.453A4.453 4.453 0 0 0 0 4.453v10.094A4.453 4.453 0 0 0 4.453 19h10.094A4.453 4.453 0 0 0 19 14.547V4.453A4.453 4.453 0 0 0 14.547 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.71 16.156h2.172a.297.297 0 0 0 .297-.296v-4.59c0-2.4-.516-4.243-3.32-4.243a2.913 2.913 0 0 0-2.613 1.427.024.024 0 0 1-.026.01.024.024 0 0 1-.018-.023v-.896a.297.297 0 0 0-.297-.297H7.844a.297.297 0 0 0-.297.297v8.314a.297.297 0 0 0 .297.297h2.172a.297.297 0 0 0 .297-.297v-4.11c0-1.162.22-2.287 1.66-2.287 1.421 0 1.44 1.33 1.44 2.363v4.034a.297.297 0 0 0 .296.297ZM2.82 4.426c0 .88.725 1.605 1.606 1.605.88 0 1.605-.725 1.605-1.606 0-.88-.725-1.605-1.605-1.605-.881 0-1.606.725-1.606 1.606Zm.517 11.73h2.175a.297.297 0 0 0 .297-.297V7.545a.297.297 0 0 0-.297-.297H3.337a.297.297 0 0 0-.297.297v8.314a.297.297 0 0 0 .297.297Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19v19H0z"
  })))));
};
export default SvgLinkedin;